import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { supabase } from "../../supabase";

const ProtectedRoute = ({ children }) => {
  const [session, setSession] = useState(undefined);

  useEffect(() => {
    // get existing session
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
    });

    // listen for login/logout
    const { data: authListener } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setSession(session);
      }
    );

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);

  // while checking session
  if (session === undefined) return null;

  // if not logged in
  if (!session) {
    return <Navigate to="/admin-login" replace />;
  }

  // if logged in
  return children;
};

export default ProtectedRoute;